import styled from 'styled-components';

import { media } from 'src/styles/breakpoints';

export const SettingsCard = styled.article`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  min-width: 0;
  box-sizing: border-box;
  padding: 1.25rem 1.5rem 1.5rem;
  border-radius: 0.5rem;
  border: 1px solid ${({ theme }) => theme.grey};
  background: ${({ theme }) => theme.background};
  box-shadow:
    0 2px 4px rgba(57, 57, 57, 0.04),
    0 8px 16px rgba(57, 57, 57, 0.04);
`;

export const SettingsCardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding-bottom: 0.25rem;
  border-bottom: 1px solid ${({ theme }) => theme.grey};
`;

export const SettingsCardTitle = styled.h2`
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: ${({ theme }) => theme.dark};
`;

export const SettingsCardDescription = styled.p`
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.midGrey};
`;

export const SettingsFields = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.25rem;

  ${media.md} {
    grid-template-columns: 1fr;
  }
`;

export const SettingField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  min-width: 0;

  & > div {
    margin-bottom: 0;
    min-width: 0;
  }

  input {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
`;

export const FieldMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  margin-top: -0.35rem;
`;

export const FieldHint = styled.span`
  font-size: 0.75rem;
  line-height: 1.35;
  color: ${({ theme }) => theme.midGrey};
`;

export const FieldPreview = styled.span`
  font-size: 0.8125rem;
  font-weight: 500;
  color: ${({ theme }) => theme.dark};
`;

export const FieldError = styled.span`
  font-size: 0.75rem;
  line-height: 1.35;
  color: ${({ theme }) => theme.negative};
`;

export const FormActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  padding-top: 0.25rem;
  border-top: 1px solid ${({ theme }) => theme.grey};
`;

export const EmptyState = styled.div`
  padding: 2rem 1rem;
  text-align: center;
  font-size: 0.9375rem;
  color: ${({ theme }) => theme.midGrey};
`;

// ---- Withdrawal fees table ----

export const FeeTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const FeeRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(0, 0.9fr) repeat(3, minmax(0, 1fr)) auto;
  gap: 0.75rem;
  align-items: start;
  padding: 0.75rem 0;
  border-bottom: 1px solid ${({ theme }) => theme.grey};

  & > div {
    margin-bottom: 0;
    min-width: 0;
  }

  input,
  select {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  ${media.md} {
    grid-template-columns: 1fr 1fr;
  }
`;

export const FeeHead = styled(FeeRow)`
  padding: 0 0 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: ${({ theme }) => theme.midGrey};

  ${media.md} {
    display: none;
  }
`;

export const FeeChain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding-top: 0.5rem;
  min-width: 0;
`;

export const FeeChainName = styled.span`
  font-size: 0.9375rem;
  font-weight: 600;
  color: ${({ theme }) => theme.dark};
`;

export const NetworkTag = styled.span`
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 0.1rem 0.5rem;
  border-radius: 999px;
  font-size: 0.6875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: ${({ theme }) => theme.midGrey};
  background: ${({ theme }) => theme.lightGrey};
`;

export const FeeWarning = styled.span`
  display: block;
  font-size: 0.75rem;
  line-height: 1.35;
  color: ${({ theme }) => theme.negative};
`;

export const FeeRowActions = styled.div`
  display: flex;
  align-items: center;
  padding-top: 0.35rem;
`;
